import { render, staticRenderFns } from "./DepositWallet.vue?vue&type=template&id=2376a876&scoped=true&"
import script from "./DepositWallet.vue?vue&type=script&lang=js&"
export * from "./DepositWallet.vue?vue&type=script&lang=js&"
import style0 from "./DepositWallet.vue?vue&type=style&index=0&id=2376a876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2376a876",
  null
  
)

export default component.exports